import {
  START_LOADING,
  END_LOADING,
  FETCH_BARCODE_SETTINGS,
  FETCH_BARCODE_SETTING,
  ADD_BARCODE_SETTING,
  UPDATE_BARCODE_SETTING,
  DELETE_BARCODE_SETTING,
  CLEAR_CURRENT_BARCODE_SETTING,
} from "../actions/constants";

const initialState = {
  isLoading: false,
  barcodeSettings: [],
  currentBarcodeSetting: null,
  numberOfPages: 0,
};

const barcodeSettingsReducer = (state = initialState, action) => {
  switch (action.type) {
    case START_LOADING:
      return { ...state, isLoading: true };

    case END_LOADING:
      return { ...state, isLoading: false };

    case FETCH_BARCODE_SETTINGS:
      return {
        ...state,
        barcodeSettings: action.payload.data,
        numberOfPages: action.payload.numberOfPages,
        isLoading: false,
      };

    case FETCH_BARCODE_SETTING:
      return { 
        ...state, 
        currentBarcodeSetting: action.payload,
        isLoading: false,
      };

    case ADD_BARCODE_SETTING:
      return {
        ...state,
        barcodeSettings: [...state.barcodeSettings, action.payload],
        currentBarcodeSetting: action.payload,
        isLoading: false,
      };

    case UPDATE_BARCODE_SETTING:
      return {
        ...state,
        barcodeSettings: state.barcodeSettings.map((setting) =>
          setting._id === action.payload._id ? action.payload : setting
        ),
        currentBarcodeSetting:
          state.currentBarcodeSetting?._id === action.payload._id
            ? action.payload
            : state.currentBarcodeSetting,
        isLoading: false,
      };

    case DELETE_BARCODE_SETTING:
      return {
        ...state,
        barcodeSettings: state.barcodeSettings.filter(
          (setting) => setting._id !== action.payload
        ),
        currentBarcodeSetting:
          state.currentBarcodeSetting?._id === action.payload
            ? null
            : state.currentBarcodeSetting,
        isLoading: false,
      };

    case CLEAR_CURRENT_BARCODE_SETTING:
      return {
        ...state,
        currentBarcodeSetting: null,
      };

    default:
      return state;
  }
};

export default barcodeSettingsReducer;